export default __webpack_public_path__ + "static/media/logo.c81481d2.svg";